module.exports = __webpack_public_path__ + "img/logo-delta.394a9a0a.png";